export default function NoResultsClipboardIcon() {
  return (
    <svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5">
        <path
          d="M80 160C124.183 160 160 124.183 160 80C160 35.8172 124.183 0 80 0C35.8172 0 0 35.8172 0 80C0 124.183 35.8172 160 80 160Z"
          fill="black"
          fillOpacity="0.04"
        />
        <path d="M118.229 41.2648H41.802V130.403H118.229V41.2648Z" fill="#ACB3BA" />
        <path d="M100.205 46.6719H47.2091V124.996H112.79V59.2885L100.205 46.6719Z" fill="white" />
        <path
          d="M97.3277 30.2292H87.1459C87.1459 25.7391 83.9522 22.1027 79.9996 22.1027C76.0471 22.1027 72.8534 25.7391 72.8534 30.2292H62.6716L59.7941 48.2529H100.174L97.3277 30.2292Z"
          fill="#384358"
        />
        <path
          d="M67.2566 59.0988H61.8178V53.6601H58.0866V59.0988H52.6479V62.83H58.0866V68.2688H61.8178V62.83H67.2566V59.0988Z"
          fill="#CF1655"
        />
        <path d="M97.0115 74.3083H62.9878V76.8695H97.0115V74.3083Z" fill="#89D3DD" />
        <path d="M106.498 115.32H92.9324V117.881H106.498V115.32Z" fill="#89D3DD" />
        <path d="M106.498 83.6996H53.5016V86.2608H106.498V83.6996Z" fill="#C2C2C2" />
        <path d="M106.498 91.3834H53.5016V93.9446H106.498V91.3834Z" fill="#C2C2C2" />
        <path d="M106.498 99.0672H53.5016V101.628H106.498V99.0672Z" fill="#C2C2C2" />
        <path d="M77.1854 106.751H53.5016V109.312H77.1854V106.751Z" fill="#C2C2C2" />
        <path d="M100.205 59.2885H112.79L100.205 46.6719V59.2885Z" fill="#E6E9EE" />
      </g>
    </svg>
  );
}
